<template>
  <div>
    <h1>Links</h1>
    <tabs v-if="tabs && tabs.length > 0">
      <tabs-item
        v-for="(tab, key) in tabs"
        :key="key"
        :active="tab.to === $route.path"
        @click="setActiveTab(tab)"
      >{{tab.title}}</tabs-item>
    </tabs>
    <section-block>
      <main v-if="!loading">
        <div v-if="type == 'system'">
          <ol class="c-quicklinks c-quicklinks--system">
            <li v-for="system in externalSystems" :key="system.id" @click="gotoLink(system)">
              <div class="c-quicklinks__icon">
                <img src="http://placehold.it/50x50" :alt="system.name">
              </div>

              <div class="c-quicklinks__title">{{system.name}}</div>
            </li>
          </ol>
        </div>

        <div v-else>
          <ol class="c-quicklinks c-quicklinks--user">
            <li v-for="link in quickLinks" :key="link.id" @click="gotoLink(link)">
              <div class="c-quicklinks__icon">
                <icon name="link" :fill="false"/>
              </div>

              <div class="c-quicklinks__title">{{link.name}}</div>
            </li>
          </ol>
        </div>
      </main>
      <loading v-else></loading>
    </section-block>
  </div>
</template>

<script>
import FilterBar from "@/components/FilterBar.vue";
import { mapState } from "vuex";
export default {
  name: "UserQuickLinks",

  methods: {
    setActiveTab(tab) {
      this.$router.push({ path: tab.to });
    },
    gotoLink(link) {
      const a = document.createElement("a");
      a.id = "generatedLink";
      a.href = link.url || link.link;
      a.target = "_blank";
      a.rel = "noopener nofollow external";
      a.click();
      document.removeChild("a#generatedLink");
    }
  },

  computed: {
    selectedTab() {
      return this.$route.params.type;
    }
  },

  data() {
    return {
      loading: true,
      type: "",
      tabs: [
        {
          to: "/quicklinks/system",
          title: "System Links"
        },
        {
          to: "/quicklinks/user",
          title: "Quick Links"
        }
      ]
    };
  },

  computed: {
    ...mapState("users", ["quickLinks"]),
    ...mapState("systems", ["externalSystems"])
  },

  mounted() {
    let action = "users/getQuickLinks";
    this.type = "user";

    if (this.$route.params.type === "system") {
      action = "systems/listExternal";
      this.type = "system";
    }
    this.$store.dispatch(action).then(resp => {
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.c-quicklinks {
  margin: 0;
  padding: 0;
  list-style-type: none;
  li {
    padding: 10px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dcdfe2;
    cursor: pointer;

    @media (hover: hover) {
      transition: all ease-in-out .2s;
      &:hover {
        box-shadow: 0 0 20px rgba(0,0,0,0.11);
      }
    }
  }

  &__icon {
    margin-right: 20px;
    max-width: 35px;
    max-height: 35px;
    img {
      border-radius: 100%;

      @supports (object-fit: cover) {
        min-height: 35px;
        width: 100%;
        min-width: 35px;
        height: 100%;
        object-fit: cover;
        max-width: 35px;
        max-height: 35px;
      }
    }
  }
}
</style>